export const TOP_HEADER_STICKY_HEIGHT = 30;
export const MOBILE_WIDTH = 480;
export const EXPAND_PAGES = ['categoriesList', 'categoryDetail', 'questionDetail', 'faqSearchPage'];
